// Hari libur nasional Indonesia 2026 (prefill standar).
// Dapat di-edit di halaman Pengaturan → Hari Libur.
// TODO-PROD: sinkronisasi dengan kalender resmi Kemenag / SKB Menteri setiap tahun.

export const HARI_LIBUR_2026 = [
  { tanggal: "2026-01-01", keterangan: "Tahun Baru Masehi" },
  { tanggal: "2026-02-17", keterangan: "Tahun Baru Imlek 2577 Kongzili" },
  { tanggal: "2026-03-19", keterangan: "Isra Mikraj Nabi Muhammad SAW" },
  { tanggal: "2026-03-20", keterangan: "Hari Suci Nyepi (Tahun Baru Saka 1948)" },
  { tanggal: "2026-03-21", keterangan: "Cuti Bersama Nyepi" },
  { tanggal: "2026-04-03", keterangan: "Wafat Isa Al Masih (Jumat Agung)" },
  { tanggal: "2026-04-05", keterangan: "Paskah" },
  { tanggal: "2026-05-01", keterangan: "Hari Buruh Internasional" },
  { tanggal: "2026-05-14", keterangan: "Kenaikan Isa Al Masih" },
  { tanggal: "2026-05-21", keterangan: "Hari Raya Idul Fitri 1 Syawal 1447 H" },
  { tanggal: "2026-05-22", keterangan: "Hari Raya Idul Fitri 2 Syawal 1447 H" },
  { tanggal: "2026-05-19", keterangan: "Cuti Bersama Idul Fitri" },
  { tanggal: "2026-05-20", keterangan: "Cuti Bersama Idul Fitri" },
  { tanggal: "2026-05-25", keterangan: "Cuti Bersama Idul Fitri" },
  { tanggal: "2026-06-01", keterangan: "Hari Lahir Pancasila" },
  { tanggal: "2026-06-02", keterangan: "Hari Raya Waisak 2570 BE" },
  { tanggal: "2026-07-27", keterangan: "Hari Raya Idul Adha 1447 H" },
  { tanggal: "2026-08-17", keterangan: "Hari Kemerdekaan RI" },
  { tanggal: "2026-08-16", keterangan: "Tahun Baru Islam 1448 H" },
  { tanggal: "2026-10-25", keterangan: "Maulid Nabi Muhammad SAW" },
  { tanggal: "2026-12-25", keterangan: "Hari Raya Natal" },
  { tanggal: "2026-12-24", keterangan: "Cuti Bersama Natal" },
  { tanggal: "2026-12-26", keterangan: "Cuti Bersama Natal" },
];
